var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxProfileStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM7.75 9.14C7.75 8.33 8.41 7.66 9.23 7.66C10.04 7.66 10.71 8.32 10.71 9.14C10.71 9.95 10.05 10.62 9.23 10.62C8.41 10.61 7.75 9.95 7.75 9.14ZM8.82 16.02C8.63 16.02 8.44 15.95 8.29 15.8C8 15.51 8 15.04 8.29 14.74L14.84 8.19C15.13 7.9 15.61 7.9 15.9 8.19C16.19 8.48 16.19 8.96 15.9 9.25L9.35 15.8C9.2 15.95 9.01 16.02 8.82 16.02ZM15.77 16.34C14.96 16.34 14.29 15.68 14.29 14.86C14.29 14.05 14.95 13.38 15.77 13.38C16.58 13.38 17.25 14.04 17.25 14.86C17.25 15.68 16.59 16.34 15.77 16.34Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxProfileStatus);
export default __webpack_public_path__ + "static/media/tax-profile-status.673421e33f9ad05923a98631f68ed474.svg";
export { ForwardRef as ReactComponent };